enum ProductType {
  ORV = 'ORV',
  MLB = 'MLB',
  MLBZ = 'MLBZ',
  GG = 'GG',
  NB = 'NB',
  EOP = 'EOP',
  BG = 'BG',
  TIB = 'TIB',
  AP = 'AP',
  HB = 'HB',
  HA = 'HA',
  IZ = 'IZ',
  UNKNOWN = 'UNKNOWN',
}

export default ProductType;
